import React from "react";
import Whatsapp from "../../images/whatsapp-chat.svg";

import "./Chat.css";

const Chat = () => {
  return (
    <div className="chat">
      <a href="https://wa.me/+17144081961" target="_blank" rel="noreferrer">
        <img src={Whatsapp} alt="" />
      </a>
    </div>
  );
};

export default Chat;
